export default "__VITE_ASSET__90dac7a9__$_?component__"